(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 767px)');
    const loadedOnMobile = mobile.matches;
    const rootSelector = '[data-esp-mobile-search]';

    function updateMenu() {
      const menu = document.querySelector('popup-component[data-esp-mobile-menu]');
      const root = document.querySelector(rootSelector);
      if (!menu || !root) return;
      const top = Math.max(0, Math.ceil(root.getBoundingClientRect().bottom));
      menu.style.setProperty('--esp-menu-top', `${top}px`);
      const open = menu.getAttribute('aria-hidden') === 'false';
      root.querySelector('[aria-controls="mobileMenu"]')?.setAttribute('aria-expanded', String(open));
      if (menu.hasAttribute('data-esp-menu-ready')) return;
      menu.setAttribute('data-esp-menu-ready', '');
      new MutationObserver(() => {
        updateMenu();
        if (mobile.matches && menu.getAttribute('aria-hidden') === 'false') {
          menu.querySelector('[data-esp-menu-search]')?.focus({preventScroll: true});
        }
      }).observe(menu, {attributes: true, attributeFilter: ['aria-hidden']});
    }

    function setOpen(root, open, restoreFocus = false) {
      const toggle = root.querySelector('[data-esp-search-toggle]');
      const input = root.querySelector('.header-search input[name="q"]');
      if (!toggle || !input) return;
      root.dataset.espSearchOpen = String(open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.searchLabel);
      if (open) input.focus({preventScroll: true});
      else {
        input.blur();
        if (restoreFocus) toggle.focus({preventScroll: true});
      }
    }

    function initialize() {
      document.querySelectorAll(rootSelector).forEach(root => {
        if (root.hasAttribute('data-esp-search-ready')) return;
        if (!root.querySelector('[data-esp-search-toggle]') || !root.querySelector('.header-search input[name="q"]')) return;
        root.dataset.espSearchReady = '';
        setOpen(root, false);
        new ResizeObserver(updateMenu).observe(root.closest('header') || root);
      });
      updateMenu();
    }

    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('[aria-controls="mobileMenu"]')) requestAnimationFrame(updateMenu);
      const menuSearch = event.target.closest('[data-esp-menu-search]');
      if (menuSearch) {
        const root = document.querySelector(rootSelector);
        const opener = root?.querySelector('[data-esp-search-toggle]');
        if (mobile.matches && loadedOnMobile && opener && root.querySelector('.header-search .snize-input-style')) {
          event.preventDefault();
          menuSearch.closest('popup-component')?.close();
          opener.click();
        }
        return;
      }
      if (!mobile.matches) return;
      const toggle = event.target.closest('[data-esp-search-toggle]');
      if (toggle) {
        const root = toggle.closest(rootSelector);
        if (root && !loadedOnMobile) {
          window.location.assign(root.dataset.espSearchResultsUrl);
          return;
        }
        // Searchanise owns its documented icon opener once it attaches to this field.
        // Keep the existing search form available while the app is unavailable.
        if (root && !root.querySelector('.header-search .snize-input-style')) {
          setOpen(root, root.dataset.espSearchOpen !== 'true');
        }
        return;
      }
      const openRoot = document.querySelector(`${rootSelector}[data-esp-search-open="true"]`);
      if (openRoot && !openRoot.contains(event.target) && !event.target.closest('.snize-ac-results')) {
        setOpen(openRoot, false);
      }
    });

    document.addEventListener('keydown', event => {
      if (!mobile.matches || event.key !== 'Escape') return;
      const root = document.querySelector(`${rootSelector}[data-esp-search-open="true"]`);
      if (root) {
        event.preventDefault();
        setOpen(root, false, true);
      }
    });

    mobile.addEventListener('change', () => {
      document.querySelectorAll(rootSelector).forEach(root => setOpen(root, false));
      updateMenu();
    });
    window.addEventListener('resize', updateMenu, {passive: true});
    window.addEventListener('scroll', updateMenu, {passive: true});
    document.addEventListener('shopify:section:load', initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
